import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type { KnowledgeRetrievalToolInput } from "@repo/app-types/entities/knowledgeRetrievalTool";
import type { KnowledgeRetrievalToolOutput } from "@repo/app-types/entities/researchAgent";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const KnowledgeRetrievalTool: ToolComponent<
  KnowledgeRetrievalToolInput,
  KnowledgeRetrievalToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return `Retrieving knowledge base document...`;
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while retrieving the knowledge base document";
    }

    if (!props.output.document) {
      return "The knowledge base document was not found";
    }

    return `Retrieved "${props.output.document.title}"`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
